// JavaScript Document
	$(document).ready(function(e) {
			
			 new WOW().init();
			$('a.mob-menu').on('click',function(){
				//$(this).toggleClass('cls');
				if($("ul.drop-down").hasClass('open')){  
					$('ul.drop-down').animate({marginLeft:-295},function(){$(this).removeClass("open");$('a.mob-menu').removeClass('cls');});
				}else{
					$('ul.drop-down').animate({marginLeft:0},function(){$(this).addClass("open");$('a.mob-menu').addClass('cls');});
				}
			});
			
			$('.flexslider').flexslider({
				animation: 'fade',
				controlsContainer: '.flexslider',
				start: function(){$(".sslider .flex-active-slide p").fadeIn(1000);},
				//before: function(){$(".flex-active-slide p").fadeIn(1000);},
				after: function(){$(".sslider .flex-active-slide p").fadeIn(1000);},
				end: function(){$(".sslider p").hide();},
			}); 
			$('a.main-option').on("click",function(){
				$('a.mob-menu').toggleClass('cls');
				$('ul.drop-down').animate({marginLeft:0});
			});   
			$('a#cls').on("click",function(){
				$('a.mob-menu').toggleClass('cls');
				$('ul.drop-down').animate({marginLeft:-295});
				$('ul.drop-down').removeClass('open');
			});
			$('.menu ul li ul li a').click(function(){
				$(this).next('ul').slideToggle();
			});
			
			///////////// Owl Carousal for products page /////////////
		/*	var owl = $('.owl-carousel');
              owl.owlCarousel({
                margin: 10,
                nav: true,
                loop: true,
                responsive: {
                  0: {
                    items: 1
                  },
                  600: {
                    items: 2
                  },
                  1000: {
                    items: 3
                }
              }
            });
         */   
      
			//////////////////////////////////////////////////////
			//------------------------------			
			//adjust height of bottom images
			//------------------------------			
			var win = $( window ).height();
			var upper = $("#upper").height();
			var bottom = $("#bottom").height();
			var new_height = win-upper;

			if(win>800){
				new_height = win-upper;
			}
			else{
				new_height = 199;
			}
			//console.log('win: '+win);
			//console.log('upper: '+upper);			
			//console.log('new_height: '+new_height);	
			
      if($( window ).width()>497){	
      $("#bottom").css("height",new_height);
			$("div.new-height").css("height",new_height);			
      }

			//------------------------------			
			//adjust height of slider images
			//------------------------------			
			
				var iw;
				var ih;

				// Get on screen image
				var screenImage = $("#upper .flexslider .slides img");
				// Create new offscreen image to test
				
				var theImage = new Image();
				$(theImage)
				.attr("src", $(screenImage).attr("src"))
				.load(function() {

					// Get accurate measurements from that.
					iw = this.width;   // Note: $(this).width() will not
					ih = this.height; // work for in memory images.
					var cw = $('#upper .top-right-wrapp').width();
					var ch = $('#upper .top-right-wrapp').height();	
					//iw = theImage.width;
					//ih = theImage.height;
					
					console.log('container width: '+cw);
					console.log('container height: '+ch);
					console.log('image width: '+iw);
					console.log('image height: '+ih);			
					
					var cratio = ch/cw;
					var iratio = ih/iw;
					if(iratio < cratio){
						$('#upper .flexslider .slides img').css('height',ch);
						$('upper .flexslider .slides img').css('width','auto');
					}
					else {
						$('#upper .flexslider .slides img').css('height','auto');
						$('#upper .flexslider .slides img').css('width',cw);
					}

				});
      
      //$("#contactFormSubmit").on('submit',function(){
        	
      //});
      
      
      //$("img.lazy").lazyload({
    	//	effect : "fadeIn",
        //	threshold : 200
		//});
      

        	});

	$(function() {
      //$("img.lazy").show().lazyload();
      $("img.lazy").lazyload({effect : "fadeIn"});
	});



		$( window ).resize(function() {


  			var win = $( window ).height();
            //var winw = $( window ).width();
			var upper = $("#upper").height();
			var bottom = $("#bottom").height();
			var new_height = win-upper;

/*			if(win>850){
				$("#bottom").css("height",new_height);
				$("div.new-height").css("height",new_height);
			}*/
			
			if(win>800){
				new_height = win-upper;
			}
			else{
				new_height = 199;
			}
			//console.log('new_height: '+new_height);			

          if($( window ).width()>375){	
            $("#bottom").css("height",new_height);
			$("div.new-height").css("height",new_height);			
          }

				// Get on screen image
				var screenImage = $("#upper .flexslider .slides img");
				// Create new offscreen image to test
				var theImage = new Image();
				theImage.src = screenImage.attr("src");
				// Get accurate measurements from that.
				var iw = theImage.width;
				var ih = theImage.height;
				var cw = $('#upper .top-right-wrapp').width();
				var ch = $('#upper .top-right-wrapp').height();	
				
				console.log('container width: '+cw);
				console.log('container height: '+ch);
				console.log('image width: '+iw);
				console.log('image height: '+ih);			
				
				var cratio = ch/cw;
				var iratio = ih/iw;
				if(iratio < cratio){
					$('#upper .flexslider .slides img').css('height',ch);
					$('upper .flexslider .slides img').css('width','auto');
				}
				else {
					$('#upper .flexslider .slides img').css('height','auto');
					$('#upper .flexslider .slides img').css('width',cw);
				}
		});
		
		$(window).load(function(){
			$('.slider-wrapp').fadeIn();
			$('.abc').fadeOut();	
		});